// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drag-handle{cursor:move}.dialog-card{height:620px;display:flex;flex-direction:column}.card-body{flex:1;overflow:hidden}.list-card{height:390px;display:flex;flex-direction:column}.scroll-list{overflow-y:auto;flex:1}", ""]);
// Exports
module.exports = exports;
